// ToggleSwitch.js
import React from 'react';
import { Switch, FormControlLabel } from '@mui/material';

function SwitchToggle({ isVisible, onToggle}) {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={isVisible}
          onChange={onToggle}
          color="primary"
          
        />
      }
      label="Private Profile"
    />
  );
}

export default SwitchToggle;
